import { connect } from 'react-redux';
import { Actions as ProductionWorkflowAdditionalTasksActions } from 'pages/production-workflow/controllers/production-workflow-additional-tasks.controller';
import { PlusIcon } from 'icons/plus';
import s from '../manage-failed-tasks-modal.module.scss';

type DispatchProps = {
  addTemporaryAdditionalTask: VoidFunction;
};
type Props = DispatchProps;

const NewAdditionalTasksHeader = ({ addTemporaryAdditionalTask }: Props) => (
  <div className={s.newly_added_additional_task_header}>
    <div>Newly added additional tasks</div>
    <div onClick={addTemporaryAdditionalTask} className={s.add_additional_task_button}>
      <PlusIcon color="#3153D6" style={{ width: '16px', height: '16px' }} /> Add additional task
    </div>
  </div>
);

const mapDispatchToProps: DispatchProps = {
  addTemporaryAdditionalTask: ProductionWorkflowAdditionalTasksActions.addTemporaryAdditionalTask,
};
export default connect(null, mapDispatchToProps)(NewAdditionalTasksHeader);
